import React from 'react';
import  { useState } from 'react';
import  { useEffect }from 'react';
import './PrimarnaPRS.css'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { componentStyles } from '../services/elementDesign.js'
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Unstable_Grid2';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';

import axios from 'axios';
import { APICall } from './services/api.service.js';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DataGrid } from '@mui/x-data-grid';

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as actions from './redux/actions.js'
import * as useLocalStorage from './services/useLocalStorage.js';

const theme = createTheme({
    palette: {
        primary: {
            main: '#520074'
        }
    },
});
function PrimarnaPRS() {


    const [curr_time, setCurrTime] = useState('');
    const [izreka, setIzreka] = useState('');
    const token = localStorage.getItem("token");
    //const { user: currentUser } = useSelector((state) => state.auth);
    const user = localStorage.getItem("user");
    const username = localStorage.getItem("username");
    const ref = localStorage.getItem("id");
    const dispatch = useDispatch();
    const isMenuOpen = useSelector(store=>store.menu?store.menu.open:false)
    const navigate = useNavigate();
    const [tableData, setTableData] = useState([])

    const toastError = {                                                        
        position: "top-center",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
   };

   const toastSuccess = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };

   const toastInfo = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };

   useEffect(() => {



}, []);
  
useEffect(()=>{
        document.title="Val"
},[])



  return (
    <ThemeProvider theme={theme}>

        <div className="PrimarnaPRS-main-container">
            <div className={`PrimarnaPRS-header ${isMenuOpen ? "is-extended": ""}`}            
                onMouseEnter={()=> dispatch(actions.openMenu())}
                onMouseLeave={()=> dispatch(actions.closeMenu())}
>
                <div className="PrimarnaPRS-header-title">
                    <Typography  variant="h5">
                       Brojevi- 06x - Dodjela Blokova
                    </Typography>

                </div>
                <div className="PrimarnaPRS-header-subtitles">
                    <Typography className="PrimarnaPRS-header-subtitle" variant="p">
                   
                    </Typography>
                    <Typography className="PrimarnaPRS-header-subtitle" variant="p">
                       Korisnik: {user}
                    </Typography>
                    <Typography className="PrimarnaPRS-header-subtitle" variant="p">
                       Broj referenta: {ref}
                    </Typography>
                    <Typography className="PrimarnaPRS-header-subtitle" variant="p">
                       Prijava : {curr_time}
                    </Typography>
                </div>
            </div>

            <div className='PrimarnaPRS-body'>


                <div className='PrimarnaPRS-form'>
                        <Grid sx={{padding:'0', margin: '0 3px'}} container spacing={0.8} columns={{xs:12}}>
                                    <Grid xs ={12}>
                                    ODLUKA AGENCIJE: (ur. broj u obliku: xxx-xx-xx-xx)
                                    </Grid>

                                    <Grid xs={6}>
                                        <TextField
                                                    InputProps={{sx:{height:40}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="Ur. broj odluke"
                                                    variant="outlined"
                                                    disabled
                                                    value={""}
                                                    onChange={(event) => {

                                                    }}
                                        />
                                    </Grid>

                                    <Grid xs={6}>
                                        <TextField
                                                    InputProps={{sx:{height:40}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="Klasa"
                                                    variant="outlined"
                                                    disabled
                                                    value={""}
                                                    onChange={(event) => {

                                                    }}
                                        />
                                    </Grid>

                                    <Grid xs={12}>
                                        <TextField
                                                    InputProps={{sx:{height:40}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="Dat. odluke (dd.mm.gggg)"
                                                    variant="outlined"
                                                    disabled
                                                    value={""}
                                                    onChange={(event) => {

                                                    }}
                                        />
                                    </Grid>

                                    <Grid xs={12}>
                                        <FormControl variant="standard" sx={{ m: 1, width:'100%' }}>
                                            <InputLabel>Operator</InputLabel>
                                            <Select
                                            fullWidth
                                        
                                            value=""
                                        
                                            label="Status Obrade"
                                            onChange={(e)=>{
                                                
                                                console.log(e.target);
                                            }}
                                            >
                                                

                                            </Select>
                                        </FormControl>                                       
                                    </Grid>

                                    <Grid xs={12}>
                                        <FormControl variant="standard" sx={{ m: 1, width:'100%' }}>
                                            <InputLabel>Vrsta odluke</InputLabel>
                                            <Select
                                            fullWidth
                                        
                                            value=""
                                        
                                            label=""
                                            onChange={(e)=>{
                                                
                                                console.log(e.target);
                                            }}
                                            >
                                                

                                            </Select>
                                        </FormControl>                                       
                                    </Grid>

                                    <Grid xs ={12}>
                                        BLOK:
                                    </Grid>

                                    <Grid xs={12}>
                                        <FormControl variant="standard" sx={{ m: 1, width:'100%' }}>
                                            <InputLabel>Akcija na bloku</InputLabel>
                                            <Select
                                            fullWidth
                                        
                                            value=""
                                        
                                            label=""
                                            onChange={(e)=>{
                                                
                                                console.log(e.target);
                                            }}
                                            >
                                                

                                            </Select>
                                        </FormControl>                                       
                                    </Grid>
                                    
                                    <Grid xs={4}>
                                        <TextField
                                                    InputProps={{sx:{height:40}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="Početak bloka"
                                                    variant="outlined"
                                                    disabled
                                                    value={""}
                                                    onChange={(event) => {

                                                    }}
                                        />
                                    </Grid>

                                    <Grid xs={4}>
                                    <TextField
                                                InputProps={{sx:{height:40}}}
                                                InputLabelProps={{
                                                    sx: {
                                                        
                                                        fontSize: "10px",
                                                        
                                                        "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                    }
                                                    }}
                                                size="small"
                                                fullWidth
                                                id=""
                                                label="Kraj bloka"
                                                variant="outlined"
                                                disabled
                                                value={""}
                                                onChange={(event) => {

                                                }}
                                    />
                                    </Grid>

                                    <Grid xs={3}>
                                        <FormControl variant="standard" sx={{width:'100%'}}>
                                            <InputLabel  sx={{height:40, top:-20}}>Veličina bloka</InputLabel>
                                            <Select
                                            fullWidth
                                            sx={{height:20}}
                                            value=""
                                        
                                            label=""
                                            onChange={(e)=>{
                                                
                                                console.log(e.target);
                                            }}
                                            >
                                                

                                            </Select>
                                        </FormControl>                                       
                                    </Grid>

                                    <Grid xs ={12} sx={{marginBottom:1}}>
                                        (unesite mrežu i telefon zajedno, dakle 7 ili 9 znamenaka; kratki kod umjesto mreže ima slova KKK)
                                    </Grid>

                                    <Grid xs={12}>
                                        <TextField
                                                    InputProps={{sx:{height:60}}}
                                                    InputLabelProps={{
                                                        sx: {
                                                            
                                                            fontSize: "10px",
                                                            
                                                            "&.MuiOutlinedInput-notchedOutline": { fontSize: "10px" }
                                                        }
                                                        }}
                                                    size="small"
                                                    fullWidth
                                                    id=""
                                                    label="Komentar na blok odluke"
                                                    variant="outlined"
                                                    disabled
                                                    value={""}
                                                    onChange={(event) => {

                                                    }}
                                        />
                                    </Grid>

                                    

                                    <Grid xs={12}>
                                        <Button sx={{height:"40px", fontSize:"10px"}} fullWidth variant="contained" color="success" 
                                                onClick={() => {
                                                
                                                }}
                                        
                                                >
                                                SPREMI PODATKE IZ ODLUKE i kreiraj<br /> VAS brojeve u bazi
                                        </Button>
                                    </Grid>

                                    <Grid xs={4}>
                                        <Button sx={{height:"40px", fontSize:"10px"}} fullWidth variant="contained" color="success" 
                                                onClick={() => {
                                                
                                                }}
                                        
                                                >
                                                SPREMI SLIKU ODLUKE
                                        </Button>
                                    </Grid>
                                    <Grid xs={4}>
                                        <Button sx={{height:"40px", fontSize:"10px"}} fullWidth variant="contained" color="info" 
                                                onClick={() => {
                                                
                                                }}
                                        
                                                >
                                                Pregled slika
                                        </Button>
                                    </Grid>
                                    <Grid xs={4}>
                                        <Button sx={{height:"40px", fontSize:"10px"}} fullWidth variant="contained" color="primary" 
                                                onClick={() => {
                                                
                                                }}
                                        
                                                >
                                                Provjera slika
                                        </Button>
                                    </Grid>

                                    <Grid xs={12}>
                                        <Button sx={{height:"40px", fontSize:"10px"}} fullWidth variant="contained" color="success" 
                                                onClick={() => {
                                                
                                                }}
                                        
                                                >
                                                Spremi samo podatke odluke (bez kreiranja VAS brojeva)
                                        </Button>
                                    </Grid>

                                    <Grid xs={6}>
                                        <Button sx={{height:"40px", fontSize:"10px"}} fullWidth variant="contained" color="info" 
                                                onClick={() => {
                                                
                                                }}
                                        
                                                >
                                                Rezerviraj blok za oduzimanje
                                        </Button>
                                    </Grid>
                                    <Grid xs={6}>
                                        <Button sx={{height:"40px", fontSize:"10px"}} fullWidth variant="contained" color="error" 
                                                onClick={() => {
                                                
                                                }}
                                        
                                                >
                                                Skini bloku rezervacije za oduzimanje
                                        </Button>
                                    </Grid>  
                                    <Grid xs ={4} sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                        <Typography >
                                            ODLUKA
                                        </Typography>

                                    </Grid>

                                    <Grid xs={8}>
                                        <Button sx={{height:"40px", fontSize:"10px"}} fullWidth variant="contained" color="info" 
                                                onClick={() => {
                                                
                                                }}
                                        
                                                >
                                                Traženje i izmjene
                                        </Button>
                                    </Grid>                                      

                                 


                                
                        </Grid>

                </div>
        
            </div>


        </div>
    </ThemeProvider >
  );
}

export default PrimarnaPRS;

